import colors from 'vuetify/lib/util/colors';

export default {
    light: {
        CONNECTED: colors.green.darken4,
        SERVICE_ERROR: colors.red.darken3,
        COMMUNICATION_FAIL: colors.red.darken3,
        UNKNOWN: colors.grey.darken2,
        EMPTY: colors.purple.darken1,
        Online: colors.green.darken4,
        Offline: colors.red.darken3,
        default: colors.grey.darken2
    },
    dark: {
        CONNECTED: colors.green.accent3,
        SERVICE_ERROR: colors.red.accent1,
        COMMUNICATION_FAIL: colors.red.accent1,
        UNKNOWN: colors.grey.lighten1,
        EMPTY: colors.purple.accent1,
        Online: colors.green.accent3,
        Offline: colors.red.accent1,
        default: colors.grey.lighten1
    }
};
